import { render, staticRenderFns } from "./slproduct.vue?vue&type=template&id=4b5382de&scoped=true&"
import script from "./slproduct.vue?vue&type=script&lang=js&"
export * from "./slproduct.vue?vue&type=script&lang=js&"
import style0 from "./slproduct.vue?vue&type=style&index=0&id=4b5382de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5382de",
  null
  
)

export default component.exports